import { endOfMonth, startOfMonth } from 'date-fns';

export function prepareEventReqDateParams(filter: { start?: Date; end?: Date; search?: string }) {
    const dateNow = new Date();
    const startDate = filter.start ? new Date(+filter.start) : startOfMonth(dateNow);
    const endDate = filter.end ? new Date(+filter.end) : endOfMonth(dateNow);

    return {
        start: startDate,
        end: endDate,
        search: filter.search,
    };
}
